/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Collation } from './collation';


export interface FilterExpression { 
    /**
     * Path to the required resource property.
     */
    property?: string | null;
    /**
     * Inner expressions. Can be used only with `and`, `or` and `not` operation.
     */
    items?: Array<FilterExpression> | null;
    /**
     * Filter operation.
     */
    operation: FilterExpressionOperation;
    collation?: Collation | null;
    /**
     * Resource property value.
     */
    value?: object | null;
}
export enum FilterExpressionOperation {
    In = 'in',
    Contains = 'contains',
    Subset = 'subset',
    Superset = 'superset',
    Equals = 'equals',
    NotEquals = 'notEquals',
    LessThan = 'lessThan',
    LessThanOrEqual = 'lessThanOrEqual',
    GreaterThan = 'greaterThan',
    GreaterThanOrEqual = 'greaterThanOrEqual',
    ExclusiveOr = 'exclusiveOr',
    Or = 'or',
    And = 'and',
    Not = 'not'
};



